import { useMemo } from 'react';

import { GENERATION_GUIDANCE_TYPE } from 'src/data/generation';
import { getToolMaxSuggestKeywords } from 'src/data/generationTool';
import { createStateSelectorHook } from 'src/lib/sweetState';

import { LocalStore } from '../store';

const useLocalState = createStateSelectorHook(LocalStore, ['generationTool', 'annotations']);

export const useAnnotationsCounter = (maxFunction, filterFunction) => {
  const { generationTool, annotations } = useLocalState();

  filterFunction =
    filterFunction ||
    ((annotation) => {
      return (
        annotation.type !== GENERATION_GUIDANCE_TYPE.campaignKeyword &&
        annotation.type !== GENERATION_GUIDANCE_TYPE.hashtag
      );
    });

  maxFunction = maxFunction || getToolMaxSuggestKeywords;

  return useMemo(() => {
    const maxCount = maxFunction(generationTool) || 1;

    const filteredAnnotations = annotations.filter(filterFunction);

    return {
      count: filteredAnnotations.length,
      maxCount,
    };
  }, [generationTool, annotations, maxFunction, filterFunction]);
};
